<nav class="em-c-tree" role="navigation" [ngClass]="innerClass" [style]="innerStyle">
  <ul au-sub-tree-navigation [navigation]="navigation" [isSubtree]="false" [route]="route" [fragment]="fragment"></ul>
</nav>